import { useContext } from "react";

import { CurrentUserContext } from "@/context/CurrentUserContext";
import { StudentType } from "@/domain/student";
import { useCurrentUserType } from "@/stores/authStore";

export const useCurrentStudent = () => {
  const currentStudent = useContext(CurrentUserContext);
  const currentUserType = useCurrentUserType();

  if (currentUserType !== "STUDENT") return null;

  if (!currentStudent) {
    throw new Error("Could not get current student");
  }

  return currentStudent as StudentType;
};
